import { Injectable } from '@angular/core'
import { take } from 'rxjs'
import { BehaviorSubject } from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class GbActivityFeedToggleService {
  public displayActivityFeedSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  public activityFeedOpenSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  hideActivityFeed(): void {
    this.displayActivityFeedSubject$.next(false)
  }
  showActivityFeed(): void {
    this.displayActivityFeedSubject$.next(true)
  }

  openActivityFeed(): void {
    this.activityFeedOpenSubject$.next(true)
  }

  closeActivityFeed(): void {
    this.activityFeedOpenSubject$.next(false)
  }

  toggleActivityFeed(): void {
    this.activityFeedOpenSubject$.pipe(take(1)).subscribe((isOpen) => {
      this.activityFeedOpenSubject$.next(!isOpen)
    })
  }
}
